import React, { useState } from "react";
import { Button, Container, Input } from "reactstrap";
import { useCreateCustomerMutation } from "../../../../redux/services/customerCreateService";
import { toast } from "react-toastify";
import { useLazyGetCustomerProfileQuery } from "../../../../redux/services/getCustomer";
import { generateToken } from "../../../../firebase";
import { useAddMessageTokenMutation } from "../../../../redux/services/userService";

interface GoogleSignUpDataProps {
  userData: any;
  setUserData: any;
  isLoading: boolean;
  setIsLoading: any;
  setIsDataModalOpen: any;
  setModalOpen: any;
}

const GoogleSignUpData: React.FC<GoogleSignUpDataProps> = ({
  userData,
  setUserData,
  isLoading,
  setIsLoading,
  setIsDataModalOpen,
  setModalOpen,
}) => {
  const [createCustomer] = useCreateCustomerMutation();
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [triggerGetCustomerInfo] = useLazyGetCustomerProfileQuery();
  const [
    addMessageToken,
  ] = useAddMessageTokenMutation();

  const validatePhoneNumber = (phone: string): boolean => {
    const cleanedPhone = phone.replace(/\D/g, "");

    if (/^94\d{9}$/.test(cleanedPhone)) {
      const formattedPhone = cleanedPhone.substring(2);
      return /^\d{9}$/.test(formattedPhone) ? true : false;
    }

    if (/^0\d{9}$/.test(cleanedPhone)) {
      const formattedPhone = cleanedPhone.substring(1);
      return /^\d{9}$/.test(formattedPhone) ? true : false;
    }

    return false;
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhoneNumber(e.target.value);
  };

  const sendMessageToken = async () => {
    const token = await generateToken();
    if (token) {
      const newCustomerId = localStorage.getItem("customerId") || "";
      if (newCustomerId !== "") {
        await addMessageToken({
          token,
          userType: "WebCustomer",
          customerId: newCustomerId,
        });
      }
    }
  };

  const handleSubmitPhoneNumber = async () => {
    setIsLoading(true);

    if (!validatePhoneNumber(phoneNumber)) {
      toast.error(
        "Invalid phone number. Please enter a valid Sri Lankan number (07XXXXXXXX or +947XXXXXXXX)."
      );
      setIsLoading(false);
      return;
    }

    const GetCustomerData = async (accessToken: string) => {
      const response = await triggerGetCustomerInfo(accessToken);
      if (response.data?.id) {
        localStorage.setItem("customerId", response.data.id);
      }
      sendMessageToken();
    };

    try {
      // Include updated userData and phoneNumber
      const updatedUserData = { ...userData, phoneNumber: phoneNumber };

      await createCustomer(updatedUserData).unwrap();

      toast.success("User details updated successfully!");
      toast.success("Google Account Signed Up Successfully!");
      setIsDataModalOpen(false);
      setModalOpen(false);
    } catch (error) {
      console.error("Error updating user details: ", error);
      toast.error("Failed to update user details.");
    } finally {
      setIsLoading(false);
      const token = localStorage.getItem("accessToken");
      if (token) {
        GetCustomerData(token);
      }
    }
  };

  return (
    <div>
      <Container>
        <h4 className="fw-bold text-light mb-1">Google Sign-Up</h4>
        <div>
          <p className="text-light mb-1">
            Please enter your phone number and review your details to continue
            the sign-up process.
          </p>

          {/* Display and Edit User Data */}
          <div className="mt-3">
            <label htmlFor="displayName">
              <strong>Display Name:</strong>
            </label>
            <Input
              type="text"
              id="displayName"
              value={userData.displayName}
              onChange={(e) =>
                setUserData({
                  ...userData,
                  displayName: e.target.value,
                })
              }
              placeholder="Enter your display name"
              disabled={isLoading}
            />
          </div>
          {/* <ControlledTextField
            label=""
            inputName="displayName"
            inputType="text"
            value={userData.displayName}
            onChange={(e) =>
              setUserData({
                ...userData,
                displayName: e.target.value,
              })
            }
            placeholder="Enter Your Name"
            isRequired={false}
            control={control}
            isDisabled={isLoading}
            rules={{
              required: true,
              pattern: /^[^-\s][A-Za-z\s]*$/,
              
            }}
          /> */}

          <div className="mt-3">
            <label htmlFor="email">
              <strong>Email:</strong>
            </label>
            <Input
              type="email"
              id="email"
              value={userData.email}
              onChange={(e) =>
                setUserData({ ...userData, email: e.target.value })
              }
              placeholder="Enter your email"
              disabled={isLoading}
            />
          </div>

          {/* <div className="mt-3">
            <label htmlFor="photoUrl">
              <strong>Photo URL:</strong>
            </label>
            <Input
              type="text"
              id="photoUrl"
              value={userData.photoUrl}
              onChange={(e) =>
                setUserData({ ...userData, photoUrl: e.target.value })
              }
              placeholder="Enter your photo URL"
              disabled={isLoading}
            />
          </div> */}

          {/* Phone Number Input */}
          <div className="mt-3">
            <label htmlFor="phoneNumber">
              <strong>Phone Number:</strong>
            </label>
            <Input
              type="text"
              id="phoneNumber"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              placeholder="Enter your phone number"
              disabled={isLoading}
              invalid={!validatePhoneNumber && phoneNumber.length > 0}
            />
            {!validatePhoneNumber && phoneNumber.length > 0 && (
              <small className="text-danger">
                Please enter a valid 10-digit phone number.
              </small>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="d-grid my-4">
          <Button
            className="btn my-2 py-2 btn-signin-color btn-block"
            onClick={handleSubmitPhoneNumber}
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default GoogleSignUpData;
